import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { TipoTransporteModel } from "../laudos-cd/tipo-transporte.model";
import { TipoTransporteService } from "../laudos-cd/tipo-transporte.service";
import { Funcoes } from "../funcoes";
import { Global } from "../global";


@Component({
  selector: 'app-tipo-transporte-form',
  templateUrl: './tipo-transporte-form.component.html'
})
export class TipoTransporteFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  tipoTransporte: TipoTransporteModel = new TipoTransporteModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private tipoTransporteService: TipoTransporteService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome_pt: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]],
      nome_en: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]],
      nome_es: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(45)]]
    });
  }

  ngOnInit() {

    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_tipo_transporte'];

      if(!this.pageIsUpd && !this.pageIsAdd){
        this.title = this.func.traduzir('front.visualizarTipoTransporte');
      }else if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarTipoTransporte');
      }else{
        this.title = this.func.traduzir('front.cadastrarNovoTipoTransporte');
      }

      if (!id) {
        return;
      }

      this.tipoTransporteService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarTipoTransporte')+': '+json.Payload[0].nome_pt;
            }else if(!this.pageIsAdd){
              this.title = this.func.traduzir('front.visualizarTipoTransporte') + ': ' + json.Payload[0].nome_pt;
            }

            this.tipoTransporte = json.Payload[0];
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.tipoTransporteService.editar(values, values.id);
    } else {
      result = this.tipoTransporteService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-cd', 'tipo-transporte']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if(json.Message && json.Message.ErrorInput){
          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/tipo-transporte/tipo-transporte-form.component.ts